<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="formTag == 1 ? '新增' : '修改'"
    width="900px"
    v-dialogDrag
    destroy-on-close
    @close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="add-ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="任务名称：" prop="taskName">
            <el-input v-model="ruleForm.taskName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否启用：" prop="status">
            <el-radio v-model="ruleForm.status" label="1">是</el-radio>
            <el-radio v-model="ruleForm.status" label="2">否</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="限速-km/h:" prop="overSpeed">
            <el-input v-model="ruleForm.overSpeed" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="允许上浮速度-km/h:"
            label-width="170px"
            prop="floatSpeed"
          >
            <el-input v-model="ruleForm.floatSpeed" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="描述：" prop="desc">
            <el-input v-model="ruleForm.desc" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="item-label">
      <span class="required">*</span><label>布控摄像头</label>
    </div>
    <div class="camera-choose">
      <div class="left-cam">
        <!-- <el-scrollbar class="scroll-bar"> -->
        <area-device-tree
          ref="deviceTree"
          v-if="dialogVisible"
          @getCameraData="getCameraData"
          @sendData="getAllTreeData"
          :multiCheck="true"
          :showPercentage="true"
        >
        </area-device-tree>
        <!-- </el-scrollbar> -->
      </div>
      <!-- <el-scrollbar class="scroll-bar right-map"> -->
      <div class="right-map">
        <div class="cam-name">
          <div class="flex-row">
            <label>摄像机：</label>
            <div class="camera-name-title ell" :title="startCameraName">
              {{ startCameraName }}
            </div>
            <span>至</span>
            <div class="camera-name-title ell" :title="endCameraName">
              {{ endCameraName }}
            </div>
          </div>
        </div>
        <div class="distance cam-name">
          <label>距离：</label>
          <el-input v-model="distance"></el-input>
          <span>m</span>
        </div>
        <!-- <div>
          <appMap ref="appMap"
                  @mapReady="mapReady"></appMap>
        </div> -->
        <div id="mini-map"></div>
      </div>
      <!-- </el-scrollbar> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit('ruleForm')">保 存</el-button>
      <el-button @click="handleClose()">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { api } from "../api";
import utils from "$utils";
import { Dic, Bus, Dates } from "$utils";
//import appMap from '@src/components/common/app-map/app-map'
import areaDeviceTree from "./camera-list"; // 区域设备树
import itemConfigurationVue from "../../assets/view/itemConfiguration.vue";

export default {
  components: {
    areaDeviceTree,
    // appMap
  },
  data() {
    return {
      ruleForm: {
        taskName: "",
        status: "",
        desc: "",
        floatSpeed: "",
        overSpeed: "",
      },
      dialogVisible: false,
      rules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
          { min: 0, max: 64, message: "长度不能超过64位", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择任务状态", trigger: "change" },
        ],
        floatSpeed: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入合法的速度数据",
            trigger: "change",
          },
        ],
        overSpeed: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入合法的速度数据",
            trigger: "change",
          },
        ],
      },
      lazyLoad: false,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      cameraData: [],
      startCameraName: "",
      endCameraName: "",
      distance: "",
      treeData: [],
      formTag: 1,
      taskCode: "",
      devices: [],
      selectedDeviceId: [],
      selectedDeviceInfo: [],
      devicesId: [],
    };
  },
  mounted() {},
  created() {},
  watch: {
    // selectedDeviceId (newVal, oldVal) {
    //   //this.selectedDeviceInfo = []
    //   newVal.forEach(item => {
    //     this.selectedDeviceInfo.push(this.devices[this.devicesId.indexOf(item)])
    //   })
    // }
    selectedDeviceInfo(newVal, oldVal) {
      console.log(newVal, this.selectedDeviceId, "======newVal");
      if (newVal.length == 1) {
        this.endCameraName = "";
        if (newVal[0].trajectory) {
          this.startCameraName = newVal[0].trajectory.deviceName;
        } else {
          this.startCameraName = newVal[0].attr.deviceName;
        }
      } else if (newVal.length == 2) {
        if (newVal[1].trajectory) {
          this.endCameraName = newVal[1].trajectory.deviceName;
        } else {
          this.endCameraName = newVal[1].attr.deviceName;
        }
      } else {
        this.startCameraName = "";
        this.endCameraName = "";
      }
      this.$refs.deviceTree.$refs.appAreaTree.setCheckedKeys(
        this.selectedDeviceId
      );
      this.cameraData = newVal.map((item) => {
        console.log(item);
        return {
          name: item.attr.deviceName,
          thirdDeviceId: item.id,
        };
      });

      console.log(this.cameraData, "=====startCameraName");
    },
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  computed: {},
  methods: {
    mapReady() {
      this.$refs.appMap.initMap();
      this.$map.setMapInstance2D(this.$refs.appMap);
      // window.eventBus.$emit('map2DReady');
      console.log("map2DReady:emit=>");
      this.$map.mapReady();
    },
    showMap() {
      this.$map.showMap2D(this.initMap);
    },
    initMap() {
      this.$map.MapInstance2D.setMapOption();
      this.$map.MapInstance2D.resetMapStyle("mini-map");
      // this.$map.MapInstance2D.getLocation(this.getLocationCB);
    },
    //地图初始
    mapInit() {
      this.queryDevicesByAreas();
      this.$map.MapInstance2D.removeTrajectory();
      this.$map.addClickEvent((e) => {
        this.$map.MapInstance2D.setMapCenter();
        if (!e.latitude || !e.longitude) {
          // 防止图标重叠 点击穿透导致地图死掉
          return;
        }
        this.$log.info("地图打点设备的信息", e);
        const curCamera = {
          ...this.devices.find((item) => {
            return item.id === e.id;
          }),
        };
        console.log(
          e,
          this.selectedDeviceId,
          "================================e"
        );
        if (this.selectedDeviceId.indexOf(e.id) !== -1) {
          this.$log.info(
            "选中的点的下标+++++++++++++++++++++",
            this.selectedDeviceId.indexOf(e.id)
          );
          this.selectedDeviceInfo.splice(
            this.selectedDeviceId.indexOf(e.id),
            1
          );
          this.selectedDeviceId.splice(this.selectedDeviceId.indexOf(e.id), 1);
          curCamera.src = "images/theme/newDark/map/resource/camera.png";
          this.$map.MapInstance2D.removePoint(e.id);
          this.$map.MapInstance2D.addMarket([curCamera]);
        } else {
          if (this.selectedDeviceId.length >= 2) {
            this.$message.warning("最多选择两个摄像机");
            return false;
          } else {
            this.selectedDeviceId.push(e.id);
            this.selectedDeviceInfo.push(e);
            curCamera.src = "./images/theme/newDark/map/camera_red.png";
            this.$map.MapInstance2D.removePoint(e.id);
          }
        }
        this.trajectory = [];
        this.selectedDeviceInfo.forEach((entity) => {
          console.log("entity+++", entity);
          entity.src = "./images/theme/newDark/map/camera_red.png";
          this.trajectory.push({
            point: [
              entity.longitude,
              entity.latitude,
              "./images/theme/newDark/map/camera_red.png",
              entity,
            ],
            id: entity.id,
          });
        });
        this.$map.MapInstance2D.removeTrajectory();
        // this.$log.debug('画轨迹点', this.trajectory)
        console.log("画轨迹点", this.selectedDeviceInfo);
        // this.$map.MapInstance2D.drawTrajectory(this.trajectory, 1.2);
        this.$map.MapInstance2D.drawTrajectory(this.trajectory, 1.222);
        // this.startCameraName=this.selectedDeviceInfo[0].attr.deviceName
        // this.endCameraName=this.selectedDeviceInfo[1].attr.deviceName
      });
    },
    //根据区域查询设备
    queryDevicesByAreas() {
      this.devices = [];
      this.$fetch("/vas/controltask/queryControlTaskCamera.json", {
        controlType: 2,
        controlFlag: "1",
      }).then((res) => {
        if (res.success) {
          let cameraList = res.returnObj;
          for (let item of cameraList) {
            console.log(item);
            if (
              item.longitude &&
              item.latitude &&
              item.longitude > 0 &&
              item.latitude > 0
            ) {
              this.devicesId.push(item.deviceId);
              this.devices.push({
                id: item.thirdDeviceId,
                name: item.deviceName,
                showTips: false,
                attr: {
                  deviceName: item.deviceName,
                  flag: 1,
                  // playDuration: true,
                  areaName: item.areaName,
                  statusName: item.status,
                  factoryName: item.factoryName,
                  createrTime: item.createrTime,
                  thirdDeviceId: item.thirdDeviceId,
                },
                url: "images/theme/newDark/map/resource/camera.png",
                longitude: item.longitude,
                latitude: item.latitude,
                height: 30,
                tipsTitle: "摄像机信息",
                tipsMap: {
                  deviceName: "摄像机名称",
                  areaName: "所属区域",
                  statusName: "状态",
                  factoryName: "厂家",
                  createrTime: "创建时间",
                },
              });
            }
          }
          console.log(this.devices, "000000000000000000");

          this.$log.info("查询到的设备--this.devices", this.devices.length);
          this.getDevices(this.devices);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    getDevices(devices) {
      // 移除地图点位数组
      this.$map.MapInstance2D.clearPoint();
      this.$map.MapInstance2D.removeTrajectory();
      // 获取地图点位数组
      // this.$map.MapInstance2D.initPage();
      this.$map.MapInstance2D.addMarket(devices);
      this.selectedDeviceId = [];
      this.selectedDeviceInfo = [];
    },
    openDialog(flag, data) {
      this.formTag = flag;
      this.$map.showMap2D(this.mapInit);
      this.dialogVisible = true;
      // this.mapReady()
      // flag 1新增 2修改
      if (this.formTag == 1) {
        setTimeout(() => {
          this.startCameraName = "";
          this.endCameraName = "";
          this.$refs.deviceTree.resetSelect();
        }, 300);
      } else {
        this.$nextTick(() => {
          this.ruleForm = data;
          this.startCameraName = data.startCameraName;
          this.endCameraName = data.endCameraName;
          this.distance = data.distance;
          this.taskCode = data.taskCode;
        });
      }
    },
    getAllTreeData(data) {
      this.treeData = data;
      if (this.ruleForm.startCameraId) {
        this.$refs.deviceTree.getTreeCheckedArr(
          this.treeData,
          this.ruleForm.startCameraId
        );
        this.$refs.deviceTree.getTreeCheckedArr(
          this.treeData,
          this.ruleForm.endCameraId
        );
      }
    },
    getLocationCB(event) {
      this.point = event;
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: this.point,
          src: "images/theme/newDark/map/resource/position_red.png",
        },
      ];
      this.$map.MapInstance2D.clearPoint();
      this.$map.MapInstance2D.addMarket(option);
    },
    handleClose() {
      this.$map.hideMap2D();
      this.$refs.deviceTree.resetSelect();
      this.$refs.ruleForm.resetFields();
      this.startCameraName = "";
      this.endCameraName = "";
      this.distance = null;
      this.dialogVisible = false;
    },
    getCameraData(data) {
      console.log(data, this.devices, "=====datagetcanera");
      // data新数据【2】，this.camerData旧数据【2，3】
      this.cameraData = data;
      if (this.cameraData) {
        this.startCameraName = this.cameraData[0]
          ? this.cameraData[0].name
          : "";
        this.endCameraName = this.cameraData[1] ? this.cameraData[1].name : "";
      }
      let trajectory = [];
      //  let selectedData= this.devices.filter(item => {
      //     data.forEach(i => {
      //       item.deviceId == i.deviceId
      //     })
      //   })
      // const curCamera = {
      //   ...this.devices.find(item => {
      //     data.forEach(i => {
      //       if (item.id === i.id) {
      //         return i
      //       }
      //     })

      //   })
      // }
      // this.$map.MapInstance2D.removePoint(item.id);
      this.devices.forEach((item) => {
        this.$map.MapInstance2D.removePoint(item.id);
      });
      this.$map.MapInstance2D.addMarket(this.devices);

      // data.forEach(e => {
      //   console.log(e, this.selectedDeviceId, '================================e')
      //   if (this.selectedDeviceId.indexOf(e.id) !== -1) {
      //     this.$log.info('选中的点的下标+++++++++++++++++++++', this.selectedDeviceId.indexOf(e.id))
      //     this.selectedDeviceInfo.splice(this.selectedDeviceId.indexOf(e.id), 1);
      //     this.selectedDeviceId.splice(this.selectedDeviceId.indexOf(e.id), 1);
      //     curCamera.src = 'images/theme/newDark/map/resource/camera.png';
      //     this.$map.MapInstance2D.removePoint(e.id);
      //   } else {
      //     this.selectedDeviceId.push(e.id);
      //     this.selectedDeviceInfo.push(e);
      //     curCamera.src = './images/theme/newDark/map/camera_red.png';
      //     this.$map.MapInstance2D.removePoint(e.id);
      //   }
      //   this.trajectory = [];
      //   this.selectedDeviceInfo.forEach(entity => {
      //     console.log('entity+++', entity)
      //     entity.src = './images/theme/newDark/map/camera_red.png'
      //     this.trajectory.push({
      //       point: [entity.longitude, entity.latitude, './images/theme/newDark/map/camera_red.png', entity],
      //       id: entity.id
      //     })
      //   })

      // })

      // this.$log.debug('画轨迹点', this.trajectory)
      console.log("画轨迹点", this.selectedDeviceInfo);
      // this.startCameraName=this.selectedDeviceInfo[0].attr.deviceName
      // this.endCameraName=this.selectedDeviceInfo[1].attr.deviceName
      data.map((item) => {
        trajectory.push({
          point: [
            item.longitude,
            item.latitude,
            `./images/theme/newDark/map/camera_red.png`,
            item,
            "speed_config",
          ],
          id: item.id,
        });
        this.$map.MapInstance2D.removePoint(item.id);
      });
      // this.devices = this.devices.filter(item => {
      //   data.forEach((i) => {
      //     if (item.deviceId == i.deviceId) {
      //       console.log(i, item)
      //       return i
      //     }

      //   })
      // });
      // this.getDevices(this.devices)
      console.log("摄像机轨迹点=====", trajectory);
      this.$map.MapInstance2D.removeTrajectory();
      this.$map.MapInstance2D.drawTrajectory(trajectory, 1.2);
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          console.log(this.cameraData, "888888888888888888888");
          if (!(this.cameraData && this.cameraData.length)) {
            this.$message.warning("请勾选测速开始/结束摄像机");
            return false;
          } else if (this.cameraData.length === 1) {
            this.$message.warning("请勾选结束摄像机");
            return false;
          }
          const params = Object.assign(this.ruleForm, {
            startCameraId: this.cameraData[0].thirdDeviceId,
            endCameraId: this.cameraData[1].thirdDeviceId,
            startCameraName: this.cameraData[0].name,
            endCameraName: this.cameraData[1].name,
            distance: this.distance,
          });
          let url;
          if (this.formTag == 1) {
            url = api.measurespeed.addMeasureSpeed;
            params.taskCode = this.taskCode;
          } else {
            url = api.measurespeed.updateMeasureSpeed;
          }
          this.$fetch(url, params).then((response) => {
            if (response && response.success) {
              this.dialogVisible = false;
              this.$message.success(response.msgContent);
              this.$parent.getList();
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "../style/speed.scss";
</style>
